export default __webpack_public_path__ + "static/media/osiscreen.8af74f4e.png";